import { IPartyV1 } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	filter: {
		id: string
	}
	update: {
		name?: string
		note?: string
	}
}

interface ResponseDataShape {
	success: boolean
	data: IPartyV1
}

export async function partyUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/party/update/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response.data
}
